import revive_payload_client_4sVQNw7RlN from "/home/ubuntu/adificial-content-player/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/ubuntu/adificial-content-player/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/ubuntu/adificial-content-player/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/ubuntu/adificial-content-player/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/ubuntu/adificial-content-player/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import components_plugin_KR1HBZs4kY from "/home/ubuntu/adificial-content-player/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/ubuntu/adificial-content-player/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/home/ubuntu/adificial-content-player/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import fonts_client_lvmIfrl4Xu from "/home/ubuntu/adificial-content-player/plugins/fonts.client.ts";
import gtag_client_Zw8EQXNVTz from "/home/ubuntu/adificial-content-player/plugins/gtag.client.ts";
import vue_toastification_client_F29MfCWaUJ from "/home/ubuntu/adificial-content-player/plugins/vue-toastification.client.ts";
import vuex_client_Id1qg9saoL from "/home/ubuntu/adificial-content-player/plugins/vuex.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  fonts_client_lvmIfrl4Xu,
  gtag_client_Zw8EQXNVTz,
  vue_toastification_client_F29MfCWaUJ,
  vuex_client_Id1qg9saoL
]